<template>
  <ul
    v-if="bookingInvoiceData"
    class="dropdown-menu pair_of_all_li w_und_767"
    id="pair_of_all_li"
    :style="
      from === 'childComponent'
        ? { right: 'auto', left: '0', top: '50px' }
        : from === 'mainComponent'
        ? { right: '0', left: 'auto' }
        : {}
    "
  >
    <li v-if="bookingInvoiceData?.is_accepted">
      <a
        href="#"
        data-toggle="modal"
        data-target="#popupi"
        @click="
          Invoice_Preview_Data(
            bookingInvoiceData?.id,
            bookingInvoiceData?.merged_invoice_id
          )
        "
        class="details_info_opt"
      >
        <span><i class="fa fa-eye"></i></span>
        <span>Preview Invoice</span>
      </a>
    </li>

    <!--                                 <li  v-if="bookingInvoiceData?.credentials?.invoiceView ">-->
    <!--                                    <a   :href="`/invoice/view/${bookingInvoiceData?.id}?id=${bookingInvoiceData?.id}`"-->
    <!--                                         class="details_info_opt">   <span><i class="fa fa-eye"></i></span>-->
    <!--                                        <span> View Invoice Page </span>-->
    <!--                                    </a>-->
    <!--                                   </li>-->

    <li>
      <a
        data-toggle="modal"
        :data-target="`.invoice-popup-modal${bookingInvoiceData?.id}`"
        v-if="from === 'mainComponent'"
      >
        <span><i class="fa fa-eye"></i></span>
        <span> View Invoice </span>
      </a>
    </li>

    <li
      class="add-payment companyHasDefaultPaymentGateway"
      v-if="
        9 !== loggedUser.role_id &&
        companyHasDefaultPaymentGatewayData &&
        bookingInvoiceData
      "
    >
      <a
        class="Group Booking Feature"
        v-if="bookingInvoiceData?.id && bookingInvoiceData?.group_customer_id"
        :href="`/payment/card/${bookingInvoiceData?.booking_id}/${bookingInvoiceData?.id}`"
      >
        <span><i class="fa fa-plus"></i></span>
        <span> Add Payment</span>
      </a>
      <a v-else :href="`/payment/card/${bookingInvoiceData?.booking_id}`">
        <span><i class="fa fa-plus"></i></span>
        <span> Add Payment</span>
      </a>
    </li>

    <li
      class="add-payment"
      v-if="9 !== loggedUser.role_id && !companyHasDefaultPaymentGatewayData"
    >
      <a
        class="Group Booking Feature"
        v-if="bookingInvoiceData?.id"
        :href="`/payment/add/${bookingInvoiceData?.booking_id}/${bookingInvoiceData?.id}`"
      >
        <span><i class="fa fa-plus"></i></span>
        <span> Add Payment</span>
      </a>
      <a v-else :href="`/payment/add/${bookingInvoiceData?.booking_id}`">
        <span><i class="fa fa-plus"></i></span>
        <span> Add Payment </span>
      </a>
    </li>

    <li>
      <a
        :href="`/invoices/add-payment-card-details/${bookingInvoiceData?.booking_id}?booking_id=${bookingInvoiceData?.booking_id}`"
      >
        <span> <i class="fa fa-money" aria-hidden="true"></i> </span>
        <span> Add Payment Method</span>
      </a>
    </li>

    <li class="add-payment" v-if="can_show_Add_Refund_button">
      <a
        v-if="bookingInvoiceData?.id"
        :href="`/refund/add/${bookingInvoiceData?.booking_id}/${bookingInvoiceData?.id}?booking_id=${bookingInvoiceData?.booking_id}&merged_invoice_id=${bookingInvoiceData?.merged_invoice_id}`"
      >
        <span><i class="fa fa-plus"></i></span>
        <span> Add Refund</span>
      </a>

      <a
        v-else
        :href="`/refund/add/${bookingInvoiceData?.booking_id}?booking_id=${bookingInvoiceData?.booking_id}&merged_invoice_id=${bookingInvoiceData?.merged_invoice_id}`"
      >
        <span><i class="fa fa-plus"></i></span>
        <span> Add Refund</span>
      </a>
    </li>

    <li
      class="add-payment"
      v-if="bookingInvoiceData?.credentials?.invoiceLabel"
    >
      <a
        href="#"
        data-toggle="modal"
        data-target="#popupi"
        @click="Invoice_Add_Label"
      >
        <span><i class="fa fa-plus"></i></span>
        <span> Add Label </span>
      </a>
    </li>

    <li  v-if="canSeeCustomer || loggedUser.role_name  != 'contractor' "  class="divider"></li>
    <li v-if="canSeeCustomer || loggedUser.role_name  != 'contractor' " class="add-payment Email_Email">
      <a @click.stop="handleClickEvent" class="customer-technician">
        <span>Email</span>
        <svg
          class="float-right"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4005_43352)">
            <path
              d="M10.0204 6L8.61035 7.41L13.1904 12L8.61035 16.59L10.0204 18L16.0204 12L10.0204 6Z"
              fill="#2E4051"
            />
          </g>
          <defs>
            <clipPath id="clip0_4005_43352">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
      <ul
        class="dropdown-content pair_of_all_li w_und_767 mobile-right-8"
        id="pair_of_all_li"
      >
        <li>
          <a
            href="#"
            data-toggle="modal"
            data-target="#popupi"
            @click="EmailInvoice"
            class="details_info_opt"
          >
            <span class="invisible_span"></span>
            <span style="padding-left: 9%">Email Invoice</span>
          </a>
        </li>
        <li class="divider"></li>
        <li
          v-if="
            bookingInvoiceData?.credentials?.hasSendBookingAsEmailCredential &&
            bookingPaymentSummaryData.total_deposit == 0
          "
        >
          <a
            id="email_booking_customer"
            href="#"
            data-toggle="modal"
            data-target="#popupi"
            @click="RequestDepositAsBooking"
            class="details_info_opt"
          >
            <span class="invisible_span"></span>
            <span style="padding-left: 9%">Request Deposit</span>
          </a>
        </li>
        <li v-else>
          <a
            href="#"
            data-toggle="modal"
            data-target="#popupi"
            @click="RequestDepositAsInvoice"
            class="details_info_opt"
          >
            <span class="invisible_span"></span>
            <span style="padding-left: 9%">Request Deposit</span>
          </a>
        </li>
      </ul>
    </li>
    <li  class="add-payment SMS_SMS"
         v-if="bookingInvoiceData?.credentials?.sendSmsTwilio && ( canSeeCustomer || loggedUser.role_name  != 'contractor' )"
    >
      <a @click.stop="handleClickEvent" class="customer-technician">
        <span>SMS</span>
        <svg
          class="float-right"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4005_43352)">
            <path
              d="M10.0204 6L8.61035 7.41L13.1904 12L8.61035 16.59L10.0204 18L16.0204 12L10.0204 6Z"
              fill="#2E4051"
            />
          </g>
          <defs>
            <clipPath id="clip0_4005_43352">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
      <ul class="dropdown-content pair_of_all_li w_und_767" id="pair_of_all_li">
        <li v-if="bookingInvoiceData?.credentials?.sendSmsTwilio">
          <a
            href="#"
            data-toggle="modal"
            data-target="#popupi"
            @click="SMSInvoice"
            class="details_info_opt"
          >
            <span class="invisible_span"></span>
            <span style="padding-left: 9%">SMS Invoice</span>
          </a>
        </li>
        <li class="divider"></li>
        <li>
          <a
            href="#"
            data-toggle="modal"
            data-target="#popupi"
            @click="RequestDepositSMS"
            class="details_info_opt"
          >
            <span class="invisible_span"></span>
            <span style="padding-left: 9%">Request Deposit</span>
          </a>
        </li>
      </ul>
    </li>

    <li class="divider"></li>

    <li class="void" v-if="bookingInvoiceData?.credentials?.convert">
      <a
        @click="
          invoice_convert_invoice_type(
            bookingInvoiceData?.id,
            'void',
            bookingInvoiceData?.merged_invoice_id
          )
        "
      >
        <span><i class="fa fa-minus-circle"></i></span>
        <span> Convert to Void</span>
      </a>
    </li>

    <li
      v-if="
        bookingInvoiceData?.merged_invoice_id == 0 &&
        bookingInvoiceData?.is_accepted &&
        bookingInvoiceData?.credentials?.hasCredentialConvertToOpen &&
        bookingInvoiceData?.invoice_type === 'draft'
      "
    >
      <a
        @click="
          invoice_convert_link_open(
            bookingInvoiceData?.id,
            'draft',
            bookingInvoiceData?.merged_invoice_id
          )
        "
      >
        <span><i class="fa fa-exchange"></i></span>
        <span>Convert to Open</span>
      </a>
    </li>

    <li
      v-if="
        bookingInvoiceData?.merged_invoice_id == 0 &&
        bookingInvoiceData?.is_accepted &&
        bookingInvoiceData?.credentials?.convert &&
        bookingInvoiceData?.invoice_type !== 'draft'
      "
    >
      <a
        @click="
          invoice_convert_invoice_type(
            bookingInvoiceData?.id,
            'draft',
            bookingInvoiceData?.merged_invoice_id
          )
        "
      >
        <span><i class="fa fa-exchange"></i></span>
        <span>Convert to Draft</span>
      </a>
    </li>

    <li
      v-if="
        bookingInvoiceData?.credentials?.convert &&
        bookingInvoiceData?.invoice_type != 'closed' &&
        applyDiscountAndCloseInvoiceData
      "
    >
      <a
        @click="
          invoice_convert_invoice_type(
            bookingInvoiceData?.id,
            'closed',
            bookingInvoiceData?.merged_invoice_id
          )
        "
      >
        <span><i class="fa fa-check-circle"></i></span>
        <span> Close Invoice </span>
      </a>
    </li>
    <li
      v-else-if="
        bookingInvoiceData?.credentials?.convert &&
        bookingInvoiceData?.invoice_type != 'closed' &&
        !applyDiscountAndCloseInvoiceData
      "
    >
      <a @click="show_confirm_close_invoice()">
        <span><i class="fa fa-check-circle"></i></span>
        <span> Close Invoice </span>
      </a>
      <confirmation-popup
        title="Apply Discount & Close Invoice"
        :message="`Would you like to automatically apply a discount equivalent to the refund amount? This allows you to easily close the invoice.`"
        id="confirm_close_invoice"
        confirm-btn-text="Yes"
        cancel-btn-text="No"
        @on-confirm="confirm_close_invoice"
        @on-cancel="hide_confirm_close_invoice"
      ></confirmation-popup>
    </li>
    <li>
      <a @click.stop="pauseResumeRemondersAction">
        <span><i class="fa fa-comments"></i> </span>
        <span>{{ pause_resume_reminders_text }}</span>
      </a>
    </li>

    <li class="divider"></li>

    <li
      v-if="
        bookingInvoiceData?.credentials?.setDueDate &&
        bookingInvoiceData?.credentials?.hasCredentialInvoices
      "
    >
      <a
        data-toggle="modal"
        data-target="#popupi"
        @click="Set_invoice_Due_Date(bookingInvoiceData?.booking_id)"
        class="details_info_opt"
      >
        <span><i class="fa fa-calendar"></i></span>
        <span>Set Invoice Due Date</span>
      </a>
    </li>

    <li>
      <a
        href="#"
        data-toggle="modal"
        data-target="#popupi"
        @click="Set_Deposit_Amount()"
      >
        <span><i class="fa fa-money"></i></span>
        <span>Set Deposit Amount</span>
      </a>
    </li>

    <li
      v-if="
        bookingInvoiceData?.merged_invoice_id && bookingInvoiceData?.is_locked
      "
    >
      <a
        :href="`/invoice/lock/0/${bookingInvoiceData?.id}?merged_invoice_id=${bookingInvoiceData?.merged_invoice_id}`"
        @click="unlockMergedinvoice()"
      >
        <span><i class="fa fa-unlock"></i></span>
        <span>Unlock Invoice</span>
      </a>
    </li>

    <li
      v-else-if="
        bookingInvoiceData?.merged_invoice_id && !bookingInvoiceData?.is_locked
      "
    >
      <a
        :href="`/invoice/lock/1/${bookingInvoiceData?.id}?merged_invoice_id=${bookingInvoiceData?.merged_invoice_id}`"
        @click="lockMergedinvoice()"
      >
        <span><i class="fa fa-lock"></i></span>
        <span>&nbsp; Lock Invoice</span>
      </a>
    </li>

    <li
      v-if="
        bookingInvoiceData?.credentials?.editInvoiceNumber &&
        bookingInvoiceData?.is_accepted
      "
    >
      <a
        href="#"
        data-toggle="modal"
        @click="edit_Invoice_Number"
        class="details_info_opt"
      >
        <span><i class="fa fa-edit"></i></span>
        <span>Edit Invoice Number</span>
      </a>
    </li>

    <li class="divider"></li>

    <li
      v-if="
        bookingInvoiceData?.credentials?.downloadInvoice &&
        bookingInvoiceData?.is_accepted
      "
    >
      <a
        :href="`/download/invoice/${bookingInvoiceData?.id}?id=${bookingInvoiceData?.id}&merged_invoice_id=${bookingInvoiceData?.merged_invoice_id}`"
      >
        <span><i class="fa fa-file-pdf-o"></i> </span>
        <span> Print Invoice PDF </span>
      </a>
    </li>

    <li v-if="bookingInvoiceData?.credentials?.hasCredentialInvoiceDelete">
      <a
        :href="`/invoice/delete/${bookingInvoiceData?.id}?id=${bookingInvoiceData?.id}&merged_invoice_id=${bookingInvoiceData?.merged_invoice_id}`"
        onclick="return confirm('are you sure you want to delete this Invoice?');"
      >
        <span><i class="fa fa-trash" style="color: red"></i></span>
        <span>Delete</span>
      </a>
    </li>
    <confirmation-popup
      title="Edit Invoice Number"
      :id="`edit-invoice-number-${bookingInvoiceData?.id}`"
      confirm-btn-text="Save"
      :showCancelBtn="true"
      cancel-btn-text="Close"
      @on-confirm="saveInvoiceNumber"
      :close-after-confirm="false"
    >
      <div class="form-group">
        <input
          ref="invoice_number"
          :value="invoice_num"
          type="text"
          class="form-control"
          placeholder="Edit invoice number"
        />
      </div>
    </confirmation-popup>
  </ul>
</template>

<script>
import { getPaymentsDetails } from "@/modules/Payment/api";

export default {
  name: "PaymentActionsDropdown",
  props: {
    loggedUser: {
      required: true,
    },
    canSeeCustomer: null,
    paymentDetails: [],
    bookingPaymentSummary: {
      type: Object,
    },
    bookingInvoice: {
      type: Object,
    },
    isParent: {
      type: Boolean,
      default: false,
    },

    from: {
      default() {
        return "mainComponent";
      },
    },
    bookingId: {
      type: Number,
      default: 0,
    },
    invoiceId: {
      type: Number,
      default: 0,
    },
    MergedInvoiceId: {
      type: Number,
      default: 0,
    },
    companyHasDefaultPaymentGateway: true,
    applyDiscountAndCloseInvoice: 0,
  },
  computed: {
    invoice_num() {
      return this.bookingInvoiceData?.merged_invoice_id
        ? this.bookingInvoiceData?.merged_invoice_num
        : this.bookingInvoiceData?.invoice_num;
    },
    remindersConfirm() {
      return this.bookingInvoiceData?.remindersConfirm
        ? this.bookingInvoiceData?.remindersConfirm
        : null;
    },
    remindersHref() {
      return this.bookingInvoiceData?.remindersHref
        ? this.bookingInvoiceData?.remindersHref
        : null;
    },
    pause_resume_reminders_text() {
      return this.bookingInvoiceData?.pause_resume_reminders_text
        ? this.bookingInvoiceData?.pause_resume_reminders_text
        : null;
    },
  },
  data() {
    return {
      bookingInvoiceData: this.bookingInvoice,
      companyHasDefaultPaymentGatewayData: this.companyHasDefaultPaymentGateway,
      applyDiscountAndCloseInvoiceData: this.applyDiscountAndCloseInvoice,
      bookingPaymentSummaryData: this.bookingPaymentSummary,
      paymentDetailsData: this.paymentDetails,
    };
  },
  methods: {
    handleClickEvent(event) {
      event.preventDefault();
    },
    getPayments() {
      getPaymentsDetails({
        booking_id: this.bookingId,
        invoice_id: this.invoiceID,
        merged_invoice_id: this.MergedInvoiceId,
        get_summary_and_invoice: true,
      }).then((response) => {
        this.paymentDetailsData = response.data.paymentDetails;
        this.applyDiscountAndCloseInvoiceData =
          response.data.apply_discount_and_close_invoice;
        if (response.data.bookingPaymentSummary) {
          this.bookingPaymentSummaryData = response.data.bookingPaymentSummary;
        }
        if (response.data.bookingInvoice) {
          this.bookingInvoiceData = response.data.bookingInvoice;
        }
        if (response.data.companyHasDefaultPaymentGateway) {
          this.companyHasDefaultPaymentGatewayData =
            response.data.companyHasDefaultPaymentGateway;
        }
      });
    },
    EmailInvoice() {
      if (
        this.bookingInvoiceData &&
        this.bookingInvoiceData?.group_customer_id
      ) {
        window.popupi(
          "Email Invoice",
          `/get-canned-responses-form/customer/email/invoice/${this.bookingInvoiceData?.id}/${this.bookingInvoiceData?.group_customer_id}/send_invoice_as_email`
        );
      } else {
        window.popupi(
          "Email Invoice",
          `/get-canned-responses-form/customer/email/invoice/${this.bookingInvoiceData?.id}/${this.bookingInvoiceData?.customer_id}/send_invoice_as_email`
        );
      }
    },
    RequestDepositAsBooking() {
      window.popupi(
        "Email Booking to Customer",
        `/get-canned-responses-form/customer/email/booking/${this.bookingInvoiceData?.booking_id}/${this.bookingInvoiceData?.customer_id}/send_booking_as_email`
      );
    },
    RequestDepositAsInvoice() {
      window.popupi(
        "Request Deposit",
        `/get-canned-responses-form/customer/email/invoice/${this.bookingInvoiceData?.id}/${this.bookingInvoiceData?.customer_id}/send_booking_deposit_as_email`
      );
    },
    SMSInvoice() {
      window.popupi(
        "Send SMS",
        `/get-canned-responses-form/customer/sms/invoice/${this.bookingInvoiceData?.id}/${this.bookingInvoiceData?.customer_id}/send+message+to+customer+for+invoice`
      );
    },
    invoice_get_status_color(type) {
      switch (type) {
        case "draft":
          type = "background-color:#A1A1A1";
          break;

        case "open":
          type = "background-color:#008CFA";
          break;

        case "overdue":
          type = "background-color:#F44336";
          break;

        case "closed":
          type = "background-color:#BCD68F";
          break;

        case "void":
          type = "background-color:#00004E";
          break;
      }
      return type;
    },
    RequestDepositSMS() {
      window.popupi(
        "Send SMS",
        `/get-canned-responses-form/customer/sms/invoice/${this.bookingInvoiceData?.id}/${this.bookingInvoiceData?.customer_id}/request_deposit`
      );
    },
    Invoice_Preview_Data(id = 0, merged_invoice_id = 0) {
      window.popupi(
        "Invoice Preview",
        `/invoice/preview/${id}?booking_id=${id}&merged_invoice_id=${merged_invoice_id}`
      );
    },
    Invoice_Add_Label() {
      window.popupi(
        "Invoice label",
        `/invoice/label/select-label/${this.bookingInvoiceData?.id}`
      );
    },
    Set_invoice_Due_Date(booking_id = 0) {
      window.popupi(
        "Set invoice Due Date",
        `/invoices/set-due-date/${booking_id}?booking_id=${booking_id}`
      );
    },
    pauseResumeRemondersAction() {
      if (confirm(this.remindersConfirm)) {
        let vm = this;
        return window.axios
          .post(vm.remindersHref + "?vue=1")
          .then(function (response) {
            vm.bookingInvoiceData.remindersHref = response.data.remindersHref;
            vm.bookingInvoiceData.remindersConfirm =
              response.data.remindersConfirm;
            vm.bookingInvoiceData.pause_resume_reminders_text =
              response.data.pause_resume_reminders_text;
          });
      }
    },
    invoice_convert_invoice_type(
      invoice_id = 0,
      type,
      merged_invoice_id,
      remove_balance_due = 0
    ) {
      let URL = `/invoice/convert/${type}/${invoice_id}?id=${invoice_id}&type=${type}&merged_invoice_id=${merged_invoice_id}&from_vue_js=1&remove_balance_due=${remove_balance_due}`;

      let vm = this;
      window.axios.get(URL).then(function (response) {
        if (response.data.message && response.data.type == "success") {
          $.notify(response.data.message, "success");
          vm.bookingInvoiceData.invoice_type = vm.invoice_type_data = `${type}`;
          vm.statusColor = vm.invoice_get_status_color(`${type}`);
          vm.$emit("invoiceTypeChanged", vm.bookingInvoiceData?.invoice_type);
          vm.$emit(
            "statusColorChanged",
            vm.invoice_get_status_color(`${type}`)
          );

          // vm.statusColor = vm.invoice_get_status_color(response.data.message);
        } else {
          $.notify(response.data.message, "error");
        }
      });
    },
    show_confirm_close_invoice() {
      if (this.bookingPaymentSummaryData.balance_due) {
        $("#confirm_close_invoice").modal("show");
      } else {
        this.invoice_convert_invoice_type(
          this.bookingInvoiceData?.id,
          "closed",
          this.bookingInvoiceData?.merged_invoice_id,
          0
        );
      }
    },
    can_show_Add_Refund_button() {
      return (
        this.bookingInvoiceData?.credentials.refundAdd &&
        this.bookingInvoiceData?.is_accepted &&
        this.paymentDetailsData.length
      );
    },
    confirm_close_invoice() {
      $("#confirm_close_invoice").modal("hide");
      this.invoice_convert_invoice_type(
        this.bookingInvoiceData?.id,
        "closed",
        this.bookingInvoiceData?.merged_invoice_id,
        1
      );
    },
    hide_confirm_close_invoice() {
      $("#confirm_close_invoice").modal("hide");
      this.invoice_convert_invoice_type(
        this.bookingInvoiceData?.id,
        "closed",
        this.bookingInvoiceData?.merged_invoice_id
      );
    },
    invoice_convert_link_open(invoice_id = 0, merged_invoice_id) {
      let URL = `/invoice/convert-link/open/${invoice_id}?id=${invoice_id}&type=open&merged_invoice_id=${merged_invoice_id}&from_vue_js=1`;
      let vm = this;
      window.axios.get(URL).then(function (response) {
        if (response.data.message && response.data.type == "success") {
          $.notify(response.data.message, "success");
          vm.bookingInvoiceData.invoice_type = vm.invoice_type_data = "open";
          vm.statusColor = vm.invoice_get_status_color("open");
          vm.$emit("invoiceTypeChanged", "open");
          vm.$emit("statusColorChanged", vm.invoice_get_status_color("open"));

          // vm.statusColor = vm.invoice_get_status_color(response.data.message);
        } else {
          $.notify(response.data.message, "error");
        }
      });
    },
    lockMergedinvoice() {
      return window.confirm(
        "Are you sure you want to lock this invoice? This action will prevent the merging of additional invoices with this invoice and will change its status to locked. "
      );
    },
    unlockMergedinvoice() {
      return window.confirm(
        "Are you sure you want to unlock this invoice? This action will allow the merging of additional invoices with this invoice and will change its status to unlocked. "
      );
    },
    edit_Invoice_Number() {
      $("#edit-invoice-number-" + this.bookingInvoiceData?.id).modal("show");
      // let vm = this;
      // vm.show_inputs("vue_invoice_num");
    },
    Set_Deposit_Amount() {
      window.popupi(
        "Set Deposit Amount",
        `/set-booking-deposit-amount/${this.bookingInvoiceData?.booking_id}`
      );
    },
    show_inputs(id = "") {
      $("#" + id + "_view").addClass("hidden");
      $("#" + id + "_show_action_btn").addClass("hidden");
      $("#" + id + "_input_section").removeClass("hidden");
      $("#" + id + "_input").val($("#" + id + "_view label").html());
    },
    saveInvoiceNumber() {
      let invoiceNum = $(this.$refs.invoice_number).val();
      let saveURL = `/invoice/edit-invoice-number/${this.bookingInvoiceData?.id}`;
      let validateURL = `/invoice`;
      let vm = this;
      let formDataInputs = new FormData();
      formDataInputs.append("invoice_number", invoiceNum);

      window.axios
        .post(validateURL, formDataInputs, {
          responseType: "json", // default
        })
        .then(function (response) {
          if (response.data.is_duplicate) {
            $.notify(
              `This invoice number already exists in the system, you can not have duplicate invoice numbers.
                    Please enter a different invoice number.`,
              "error"
            );
          } else {
            window.axios
              .post(saveURL, formDataInputs, {
                responseType: "json", // default
              })
              .then(function (response) {
                $("#edit-invoice-number-" + vm.bookingInvoiceData?.id).modal(
                  "hide"
                );
                $("#vue_invoice_num_view label").html(invoiceNum);

                $.notify(
                  `Your invoice has been updated to ` + invoiceNum,
                  "success"
                );
              });
          }
        });
    },
  },
  mounted() {
    if (!this.bookingInvoiceData && this.isParent) {
      this.getPayments();
    }
    $("#popupi").on("shown.bs.modal", function () {
      $("#popupi").css("z-index", 1080);
    });
    $("#popupi").on("hidden.bs.modal", function () {
      $("#popupi").css("z-index", 1050);
    });
  },
};
</script>
<style scoped>
.dropdown-content {
  margin-left: 0;
  left: 0;
  right: auto;
  padding-left: 0;
}
.details_info_opt .invisible_span {
  display: block; /* Makes the span take up the full width */
  visibility: hidden; /* Hides the span, but it still takes up space */
}
.details_info_opt {
  display: inline-block; /* Makes the anchor block level */
  text-decoration: none; /* Optional: removes underline from links */
}
</style>
